import React, { useEffect, useMemo, useState } from 'react';
import { ModuleBridge, TopActionBar } from '../../components';
import { ActionBar } from './ActionBar';
import { useGetUserQuery, useLazyGetOrganizationQuery } from '../../api';
import { getSessionVar } from '../../lib/helpers';
import { UserRoles } from '../../constants';

export const ReportingEntitlementsConsumption = () => {
    const id = sessionStorage.getItem('loggedInUserId');
    const { data: userInfo } = useGetUserQuery({ id }, { skip: !id });
    const [getUserOrganization] = useLazyGetOrganizationQuery();
    const [organizations, setOrganizations] = useState([]);

    const isSupportOrSysAdmin = useMemo(() => {
        const systemRole = sessionStorage.getItem('systemRole');
        const userRole = sessionStorage.getItem('userRole');
        const rolesWithFullOrgAccess = [UserRoles.ADMIN, UserRoles.SUPPORT];

        return rolesWithFullOrgAccess.includes(systemRole) || rolesWithFullOrgAccess.includes(userRole);
    }, []);

    useEffect(() => {
        (async () => {
            if (isSupportOrSysAdmin) {
                let orgId = getSessionVar('organizations')?.find((org) => !org.parent_organization_id)?.id;
                const result = await getUserOrganization({ orgId: orgId });
                setOrganizations(result?.data?.child_organizations || []);
            } else {
                setOrganizations(userInfo?.organizations || []);
            }
        })();
    }, [userInfo, isSupportOrSysAdmin]);

    return (
        <div className={'reporting-entitlements-consumption'}>
            <TopActionBar>
                <ActionBar
                    isSupportOrSysAdmin={isSupportOrSysAdmin}
                    userRole={userInfo?.role}
                    userOrganizations={organizations}
                />
            </TopActionBar>
            <div id="backbone_reporting_wrapper"></div>
            <ModuleBridge moduleId="reporting_entitlements_consumption_module" />
        </div>
    );
};
